export const getYearsFrom = (year = 1998) => {

    const currentYear = new Date().getFullYear();
    const years = [];
    for(let i = year; i <= currentYear + 2; i++){
        years.push(i);
    }
    return years;

}